import styled from "styled-components";
import styles from "./profile.module.css";
// import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
// import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
// import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined';
import { useHistory } from "react-router";
import axios from "axios";
import { useSelector } from "react-redux";
import { PostComp } from "./PostComp";
import { v4 as uuid } from 'uuid';

const ActivityDiv = styled.div`
background-color: rgb(245,247,250);
display: flex;
flex-direction: column;
width: 105.7%;
/* border: 1px solid green; */
margin:15px auto;
border-radius: 8px;
`;
const Post = styled.div`
cursor: pointer;
padding: 11px;
width: 96%;
min-height: 210px;
background-color: white;
/* border: 1px solid #081b3d; */
border: 1px solid #eaeff8;
padding-bottom: 0;
display: flex;
flex-direction: column;
margin: 5px 0px;
border-radius: 8px;
`;
export const PostCard = ({ posts }) => {
    const loggedInUser = useSelector(state => state.loggedInUser);
    const loggedIn = useSelector(state => state.loggedIn);
    const history = useHistory();
    const url = process.env.REACT_APP_url;

    const getDate = (val) => {
        let joined = val.slice(0, 10).split("-").reverse();
        let month;
        switch (joined[1]) {
            case "01": month = "January";
                break;
            case "02": month= "February";
                break;
            case "03": month = "March";
                break;
            case "04": month= "April";
                break;
            case "05": month = "May";
                break;
            case "06": month= "June";
                break;
            case "07": month = "July";
                break;
            case "08": month= "August";
                break;
            case "09": month = "Sep";
                break;
            case "10": month= "Oct";
                break;
            case "11": month = "November";
                break;
            case "12": month= "December";
                break;
            default: month = "October";
                break;
        }
        let str = `${month} ${joined[0]}, ${joined[2]}`;
        return str;
    }
    const addBookmark = (postid) => {
        axios.patch(`${url}/users/addbookmark/${loggedInUser._id}/post/${postid}`)
            .then((res) => {
                console.log(res.data.user);
            })
            .catch((err) => {
                alert(err);
            })
    }
    return (
        <div>
            <ActivityDiv>
                {posts.map((item) => (
                    <PostComp key={uuid()} item={item}/>
                                // <Post>
                                //     <div onClick={() => history.push(`/users/${item.author.username}`)} className={styles.postAuthorDetails}>
                                //         <div className={styles.authorImgDiv}>
                                //             <img src={`/profile_pics/${item.author.profile_pic}`} alt="profile"/>
                                //         </div>
                                //         <div className={styles.authorDets}>
                                //             <div>{item.author.name}</div>
                                //             <div>{getDate(item.createdAt) }</div>
                                //         </div>
                                //     </div>
                                //     <div onClick={() => history.push(`/posts/${item._id}`)} className={styles.title}>{item.title}</div>
                                //     <div className={styles.postSub}>
                                //         <div>
                                //             {item.body?.slice(0, 280) + "..."}
                                //         </div>
                                //         <div className={styles.postImgDiv}>
                                //             <img className={styles.postImg} src={`/profile_pics/${item.image}`}alt="post"/>
                                //         </div>
                                //     </div>
                                //     <div className={styles.postStats}>
                                //         <div className={styles.stats1}>
                                //             <div style={{display:"flex", alignItems:"center"}}>
                                //             <ThumbUpAltOutlinedIcon style={{width:"28px", marginRight:"5px"}} fontSize="large" className={styles.icons}/>
                                //             <p>{ item.likes}</p>
                                //             </div>
                                //             <div style={{display:"flex", alignItems:"center"}}>
                                //             <CommentOutlinedIcon style={{width:"28px", marginRight:"5px"}} fontSize="large" className={styles.icons} />
                                //             <p>19</p>
                                //             </div>
                                //         </div>
                                //         <div>
                                //             <BookmarkBorderOutlinedIcon onClick={() => addBookmark(item._id)} className={styles.icons} fontSize="large"/>
                                //         </div>
                                //     </div>
                                // </Post>
                            ))}                    
                </ActivityDiv>
        </div>
    )
}